import { CONTRACT_CANCEL } from './index';
import { Action } from '../action';
import { SubscriptionService } from '@shared/core';

export class ContractCancelInitAction implements Action {
	readonly type = CONTRACT_CANCEL.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCancelDestroyAction implements Action {
	readonly type = CONTRACT_CANCEL.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCancelClickBackAction implements Action {
	readonly type = CONTRACT_CANCEL.CLICK_BACK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractCancelClickCancelAction implements Action {
	readonly type = CONTRACT_CANCEL.CLICK_CANCEL;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class ContractCancelSelectDateAction implements Action {
	readonly type = CONTRACT_CANCEL.SELECT_DATE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class ContractCancelSelectServiceAction implements Action {
	readonly type = CONTRACT_CANCEL.SELECT_SERVICE;
	constructor(
		public payload: SubscriptionService,
		public correlationId?: number
	) {}
}
